import React, { useState } from 'react';
import { Star, X } from 'lucide-react';
import './ReviewModal.css';

const avatarContext = require.context('@/assets/avatar', false, /\.(png|jpe?g|svg|webp)$/);
const AVATARS = avatarContext.keys().map(key => avatarContext(key));

const ReviewModal = ({ onClose, productId }) => {
    const [selectedAvatar, setSelectedAvatar] = useState(0);
    const [name, setName] = useState('');
    const [comment, setComment] = useState('');
    const [rating, setRating] = useState(0);

    const handleSubmit = () => {
        if (!name || !comment || rating === 0) return;
        // Aquí conectas con tu backend o estado global
        console.log({ productId, avatar: AVATARS[selectedAvatar], name, comment, rating });
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>

                {/* Botón cerrar */}
                <button className="modal-close" onClick={onClose}>
                    <X size={16} color="#888" />
                </button>

                <p className="modal-title">Deja tu reseña</p>
                <p className="modal-subtitle">Elige tu avatar</p>

                {/* Selector de avatar */}
                <div className="avatar-selector">
                    {AVATARS.map((av, i) => (
                        <div
                            key={i}
                            className={`avatar-option ${selectedAvatar === i ? 'selected' : ''}`}
                            onClick={() => setSelectedAvatar(i)}
                        >
                            <img src={av} alt={`avatar-${i}`} className="avatar-img" />
                        </div>
                    ))}
                </div>

                {/* Nombre */}
                <input
                    className="modal-input"
                    placeholder="Tu nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                {/* Comentario */}
                <textarea
                    className="modal-textarea"
                    placeholder="Escribe tu comentario"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />

                {/* Estrellas */}
                <span className="modal-label">Selecciona tu puntuación</span>
                <div className="modal-stars">
                    {Array.from({ length: 5 }, (_, i) => (
                        <Star
                            key={i}
                            size={28}
                            fill={i < rating ? '#FFB84D' : 'none'}
                            color={i < rating ? '#FFB84D' : '#ccc'}
                            strokeWidth={1.5}
                            onClick={() => setRating(i + 1)}
                            style={{ cursor: 'pointer' }}
                        />
                    ))}
                </div>

                {/* Botón enviar */}
                <button className="modal-submit" onClick={handleSubmit}>
                    Enviar reseña
                </button>

            </div>
        </div>
    );
};

export default ReviewModal;